import moment from 'moment';
import { parseDate } from '@datepicker-react/hooks';

import {
  C4CSalesItemType,
  TourAvailabilityStatusType,
  TourType,
} from '@api/index';
import {
  formatISOToDate,
  FORM_DATE_FORMAT,
  getAgeFromFormattedString,
  isAfterDateTime,
  getCurrentDate,
} from '@utils/dateUtil';
import { TourPackageProps } from '@contexts/tour-detail/TourDetail';

import { Guest } from '../TourRoomGuest/props';
import { HandlersConfig } from './props';

export const TourTypesSalesItemMap: Record<TourType, C4CSalesItemType> = {
  [TourType.ABROAD]: C4CSalesItemType.TUR_YURT_DISI,
  [TourType.CRUISE]: C4CSalesItemType.TUR_CRUISE,
  [TourType.DOMESTIC_CULTURE]: C4CSalesItemType.TUR_KULTUR,
};

export const getButtonConfig = (
  handlersConfig: HandlersConfig,
  status?: TourAvailabilityStatusType,
  full?: boolean
) => {
  const key = status ?? 'defaultHandler';
  const handler = handlersConfig[key] ?? handlersConfig['defaultHandler'];
  if (full)
    return {
      label: 'Biz Sizi Arayalım',
      handler: handlersConfig['defaultHandler'],
    };
  switch (status) {
    case TourAvailabilityStatusType.AVAILABLE:
      return {
        label: 'Turu Seç',
        handler,
      };
    default:
      return {
        label: 'Biz Sizi Arayalım',
        handler,
      };
  }
};

// =============================
// Get the children for a guests
// =============================
export const getChildrenBirthDates = (childList: Guest['childList']) => {
  return (
    childList?.map(
      (child) => moment(child.date).add('days', 1) as unknown as string
    ) ?? []
  );
};

// ========================================
// Validate the birth dates for the children
// ========================================
export const checkBirthDates = (room: Guest) => {
  let hasError = false;
  const data =
    room && room?.childList?.length !== 0
      ? {
          ...room,
          childrenList:
            room?.childList &&
            room?.childList?.map((kid) =>
              !kid || String(kid.date) === '' || String(kid.date).length < 10
                ? ((hasError = true), (kid.error = true), kid)
                : ((kid.error = false), kid)
            ),
        }
      : room;
  return { hasError, room: data };
};

// ==============================
//  Get the total guest count
// ==============================
export const getGuestsCount = (guests: Guest[]) => {
  const adultCount = guests
    ?.map((item) => item.adultNumber)
    .reduce((acc, val) => acc + val);

  const childCount = guests
    ?.map((item) => item.childList?.length || 0)
    .reduce((acc, val) => acc + val);

  return adultCount + childCount;
};

// ===================================
//  Get the info modal text base on guests
// ===================================
export const getGuestsInfoModalText = (guestItems: Guest) => {
  const { adultNumber, childList } = guestItems;

  if (adultNumber === 1 && childList?.length === 1)
    return 'Tek yetişkin seçiminde çocuk fiyatı geçersizdir, yetişkin olarak hesaplanacaktır.';
  else if (adultNumber === 1 && childList?.length === 2)
    return 'Tek yetişkin seçiminde, çocuklardan biri yetişkin fiyatı üzerinden hesaplanacaktır.';
  else return '';
};

// ===================================
// check if tour child age is valid
// ===================================

const regex = /^([0-2][0-9]|(3)[0-1])(\/)(((0)[0-9])|((1)[0-2]))(\/)\d{4}$/;
export const validTourChildAge = (date: Date | null) => {
  let isValid = true;

  const formattedDate = formatISOToDate(String(date), FORM_DATE_FORMAT);
  const ageFromYears = getAgeFromFormattedString(
    formatISOToDate(String(date), FORM_DATE_FORMAT),
    FORM_DATE_FORMAT
  );
  const notValidAge = isAfterDateTime(
    moment(date),
    moment(
      parseDate(
        getCurrentDate().format(FORM_DATE_FORMAT),
        String(`dd/MM/yyyy`),
        new Date()
      )
    )
  );

  !date ||
  String(date) === '' ||
  String(formattedDate).length < 10 ||
  regex.test(String(formattedDate)) === false ||
  ageFromYears > 11 ||
  notValidAge
    ? (isValid = false)
    : (isValid = true);

  return isValid;
};

// ===================================
// check if tour room children ages are valid
// ===================================
export const validateSingleTourRoomChildrenAges = (room: Guest) => {
  let isValid = true;

  for (const item of room?.childList || []) {
    if (!validTourChildAge(item.date)) isValid = false;
  }

  return isValid;
};

// =============================================
// check if we should delete all tour package rooms
// =============================================
export const shouldDeleteAllTourPackageRooms = (
  roomIndex: number,
  currentPackage?: TourPackageProps
) => {
  let shouldDeleteAllRooms = false;
  if (
    roomIndex === 0 &&
    currentPackage &&
    currentPackage.rooms &&
    currentPackage.rooms.length > 1
  ) {
    const [firstRoom, ...otherRooms] = currentPackage.rooms;

    const inValidRooms = otherRooms.every(
      (room) =>
        !room ||
        !room.selectedVariationItems ||
        room.selectedVariationItems.length === 0
    );

    if (inValidRooms && (firstRoom?.selectedVariationItems?.length || 0) > 0) {
      shouldDeleteAllRooms = true;
    } else {
      shouldDeleteAllRooms = false;
    }
  } else {
    shouldDeleteAllRooms = false;
  }

  return shouldDeleteAllRooms;
};
